export const kDefaultProfileIconUri = "/images/icons/ProfileIcon.png";
export const kLoadingSpinner = "/images/loading-waiting.gif";
export const kDefaultImage = "/images/default-image.png";
export const kDefaultShopBrandsHeader = "/images/ShopBrandsHeader.png";
export const kBrandHeader = "/images/ShopBrandsHeader.png";
export const kSrcSizes = [300, 512, 1024, 2048] as const;
export const kPhonePattern = /\(\d{3}\) ?\d{3}-\d{4}/;
export const kDefaultHit = {
  objectID: "",
  brandStory: "",
  name: "",
  tags: [],
  categories: { lvl0: [], lvl1: [] },
  brandEthos: [],
  isExclusive: false,
  openingMin: 0,
  reorderMin: 0,
  "images.logoDownloadURL": "",
  "images.heroes": [],
};
export const kEmailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gim;

export const kIbanRegex =
  /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{4}[0-9]{3}([a-zA-Z0-9]?[a-zA-Z0-9]{0,4}[a-zA-Z0-9]{0,4}[a-zA-Z0-9]{0,4}[a-zA-Z0-9]{0,3})?$/;

export const getBalanceError = (errorMessage: string): string => {
  if (errorMessage === "name should not be empty") {
    return "Please enter your business name";
  } else if (errorMessage === "emailAddress must be an email") {
    return "Please enter a valid email address";
  } else if (errorMessage === "emailAddress should not be empty") {
    return "Please enter an email address";
  } else if (errorMessage === "businessDomain should not be empty") {
    return "Please enter a business domain";
  } else if (errorMessage === "businessDomain must be a valid domain name") {
    return "Please enter a domain with this format: www.website.com";
  } else if (errorMessage === "billingAddress.addressLine1 should not be empty") {
    return "Please enter a street address";
  } else if (errorMessage === "billingAddress.city should not be empty") {
    return "Please enter your a city";
  } else if (errorMessage === "address.addressLine1 should not be empty") {
    return "Please enter a street address";
  } else if (errorMessage === "address.city should not be empty") {
    return "Please enter a city name";
  } else if (errorMessage === "url must be an URL address") {
    return "Please enter a valid URL address";
  } else if (errorMessage === "Invalid US state or province") {
    return "Please enter a valid US state";
  } else if (errorMessage === "Invalid US postal code") {
    return "Please enter a valid zipcode";
  } else if (errorMessage === "Routing number must have 9 digits") {
    return "Routing number must have 9 digits";
  } else if (errorMessage === "bankAccountDetails.accountNumber should not be empty") {
    return "Please enter banking account number";
  } else if (
    errorMessage ===
    "You passed an empty string for 'bank_account[routing_number]'. We assume empty values are an attempt to unset a parameter; however 'bank_account[routing_number]' cannot be unset. You should remove 'bank_account[routing_number]' from your request or supply a non-empty value."
  ) {
    return "Please enter a bank account routing number";
  }
  return "Something went wrong. Please try again later";
};

export const kTablePageSize = 20;

export const kBaseSiteUrl = new URL(window.location.href).origin;
